// Libraries
import Tippy from 'Components/flowChart/components/Tippy';
import { getLabelWidth, iconWidth } from 'Components/flowChart/index.style.js';
import React from 'react';
import styled from 'styled-components';

export const CardContent = styled.div`
	overflow: auto;

	::-webkit-scrollbar {
		width: 4px;
	}

	::-webkit-scrollbar-track {
		background: #f9f9f9;
	}

	::-webkit-scrollbar-thumb {
		background: #e5e5e5;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #e5e5e5;
	}
`;

export const CardBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 5px 0;
`;

export const CardIcon = styled.i`
	font-size: 16px;
	color: #666666;
`;

export const Card = styled.div<{ firstNode?: boolean }>`
	/* position: absolute;
	top: calc(${iconWidth} + 6px);
	left: 0; */

	display: flex;
	flex-direction: column;
	width: ${getLabelWidth(true)};
	max-height: 100px;
	padding: 5px;
	background-color: #fff;
	box-shadow: 0px 3px 3px 0px #002e591a;
	border-radius: 3px;

	z-index: 5;

	${CardBlock} {
		&:not(:last-child) {
			border-bottom: 1px solid #e5e5e5;
		}
	}
`;

/* CardText */

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const Text = styled.p`
	font-family: Roboto;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	margin: 0;
	color: #595959;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Icon = styled.i`
	font-size: 16px;
	color: #666666;
`;

interface IProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
	icon?: string | React.ReactNode;
}

export const CardText: React.FC<IProps> = (props) => {
	const { children, icon } = props;
	const disabledTippy = typeof children === 'string' && children.length < 24;

	const renderIcon = () => {
		if (!icon) return null;

		if (typeof icon === 'string') return <Icon className={icon} />;

		return icon;
	};

	return (
		<Tippy arrow content={children as string} disabled={disabledTippy}>
			<Wrapper>
				{renderIcon()}
				<Text>{children}</Text>
			</Wrapper>
		</Tippy>
	);
};
